import {useTranslation} from 'react-i18next';

import type {BlogPost} from 'types/payload-types';

/**
 * Hook für die Blog-Übersichtsseite. Leitet das Header-Bild des ersten Beitrags her
 * (für die Meta-Vorschau), damit die Seitenkomponente selbst auf einen einzigen
 * Hook-Aufruf reduziert bleibt (siehe `@nfq/component-single-hook`).
 *
 * @param posts Die veröffentlichten Blog-Beiträge.
 * @returns Übersetzungsfunktion und das Header-Bild des ersten Beitrags.
 */
export const useBlogIndexPage = (posts: BlogPost[]) => {
    const {t} = useTranslation();
    const firstHeaderImage = typeof posts[0]?.headerImage === 'object' ? posts[0].headerImage : null;

    return {
        firstHeaderImage,
        t
    };
};